export default values => {
  const isMultiEquipment = values?.equipmentsList?.length > 1;
  const firstEquipment = values?.equipmentsList?.[0];
  const base = {
    ...values,
    equipment: {
      brandId: firstEquipment?.brand?.id || null,
      brand: firstEquipment?.brand?.name || '',
      model: firstEquipment?.model || '',
      isHidden: firstEquipment?.isHidden ?? false
    }
  };
  if (isMultiEquipment && values?.equipmentsList?.length) {
    if (values.equipments?.length) {
      base.equipments = values.equipments;
    } else {
      base.equipments = values.equipmentsList.map(item => ({
        brandId: item?.brand?.id ?? null,
        brand: item?.brand?.name || item?.brand || '',
        model: item?.model ?? '',
        isHidden: item?.isHidden ?? false
      }));
    }
  }
  return base;
};
